module.exports = __webpack_public_path__ + "static/media/Risorsa 008.db6cf48b.svg";